import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { Close as CloseIcon, ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { colors, fonts, spacing, shadows } from '../../../constants';

/**
 * FormHeader Component
 * Header with title and close/back button
 * 
 * @param {string} heading - Header title
 * @param {boolean} isModal - Whether form is in modal layout
 * @param {Function} onCancel - Cancel handler
 */
const FormHeader = ({ heading, isModal, onCancel }) => (
  <Box
    sx={{
      padding: `${spacing.xs} ${spacing.sm}`,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      background: colors.primaryGradient,
      position: isModal ? 'sticky' : 'relative',
      top: 0,
      zIndex: 1,
      boxShadow: shadows.sm,
    }}
  >
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <Typography
        component="h2"
        variant="h5"
        sx={{
          fontWeight: fonts.weightBold,
          fontSize: fonts.fontSize2xl,
          color: colors.textWhite,
          letterSpacing: '-0.5px',
        }}
      >
        {heading}
      </Typography>
      <IconButton
        onClick={onCancel}
        sx={{
          color: colors.textWhite,
          padding: spacing.xs,
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.22)',
            color: colors.textWhite,
            transform: isModal ? 'rotate(90deg)' : 'none',
          },
        }}
      >
        {isModal ? <CloseIcon /> : <ArrowBackIcon />}
      </IconButton>
    </Box>
  </Box>
);

export default FormHeader;
